import { useDataChange, useDataValue } from 'Simple/Data.js'
import {
  getAdjustedTreatmentFeeAfterInsurances,
  changeDiscountsAppliedToPayorsShare,
  changePayorsConfiguration,
} from 'Data/payment-plan.js'

export function useOnChange(props) {
  let index = useDataValue({
    context: 'payor_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'payment_plan',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      let payor = next.payors[index]
      payor.share.percentage = value

      let treatment_fee = getAdjustedTreatmentFeeAfterInsurances(next)
      payor.share.amount = parseFloat(
        ((treatment_fee * value) / 100).toFixed(2)
      )

      if (next.payors.length > 1) {
        let other_payor = next.payors.find(
          (_, other_index) => other_index !== index
        )
        let percentage = 100 - payor.share.percentage
        other_payor.share.percentage = percentage
        // assign the difference to prevent "off-by-1-penny" issue due to rounding
        other_payor.share.amount = parseFloat(
          (treatment_fee - payor.share.amount).toFixed(2)
        )
      }

      changeDiscountsAppliedToPayorsShare(next)
      changePayorsConfiguration(next)
    })
  }
}
